import { DropdownOption } from '../../components/dropdown/dropdown-primary/dropdown.interface';

export enum ImportFuelCardStatus {
  CREATED = 'CREATED',
  UPDATING = 'UPDATING',
  UPDATED = 'UPDATED',
  INTERRUPTED = 'INTERRUPTED',
  ERROR = 'ERROR',
  MAPPING_NEEDED = 'MAPPING_NEEDED',
}
export enum LogsStatus {
  IMPORT_COMPLETED = 'Import completed',
  MAPPING_NEEDED = 'Mapping needed. Go to the Fuel Card Mapping Rows section to create the mappings',
}

export interface FuelCardTypeResponse {
  items: FuelCardType[];
  count: number;
}

export interface FuelCardType {
  id: string;
  name: string;
}

export interface CreateImportFuelCardTypeRequest {
  sourceFileId: string;
  fuelCardTypeId: string;
  name: string;
}

export interface ItemImportFuelCardFileModel {
  id: string | null;
  tenantId: string | null;
  name: string | null;
  sourceFileId: string | null;
  fuelCardTypeId: string | null;
  creationDate: string | null;
  confirmed: boolean | null;
  status: string | null;
  totalRows: number | null;
  validatedRows: number | null;
  importedRows: number | null;
  createdByUserId: string | null;
  log: string | null;
  errors: string[] | null;
  fuelCardTypeModel: FuelCardType | null;
}

export interface ImportFuelCardFileClient extends ItemImportFuelCardFileModel {
  actions?: DropdownOption[];
  statusClient?: { text: string; tooltip: string; cssClass?: string };
}
